export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/intercom.1a5b4260.svg","height":32,"width":140};